// This component will be used for User Badges and Tags and auto-complete tokens
import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const tokenSizes = {
   sm: {
      height: '15px',
      padding: '0px 4px',
      textSize: '0.85'
   },
   md: {
      height: '20px',
      padding: '0px 7px',
      textSize: '1.5'
   },
   lg: {
      height: '25px',
      padding: '0px 10px',
      textSize: '2'
   }
}

const Token = ({
   backgroundColor,
   marginBottom,
   marginRight,
   name,
   rightDetail,
   size,
   textColor
}) => (
   <View
      flex="0 0 auto"
      display="inline-flex"
      alignItems="center"
      height={tokenSizes[size].height}
      backgroundColor={backgroundColor}
      borderRadius="3px"
      marginBottom={marginBottom}
      marginRight={marginRight}
      padding={tokenSizes[size].padding}>
      <Text
         size={tokenSizes[size].textSize}
         color={textColor}>
         {name}
      </Text>
      {rightDetail}
   </View>
)

Token.propTypes = {
   backgroundColor: PropTypes.string,
   marginBottom: PropTypes.string,
   marginRight: PropTypes.string,
   name: PropTypes.string.isRequired,
   rightDetail: PropTypes.node,
   size: PropTypes.oneOf(['sm', 'md', 'lg']),
   textColor: PropTypes.string
}

Token.defaultProps = {
   backgroundColor: '#eee',
   marginBottom: undefined,
   marginRight: '3px',
   rightDetail: undefined,
   size: 'sm',
   textColor: '#555'
}

export default Token
